import { getChildOutlineSectionsByIndex } from "utils/proposals";

export const addNestingLevelToSections = (sections, currentLevel = 0) => {
  if (!sections || !Array.isArray(sections)) {
    return sections;
  }

  return sections.map((section) => ({
    ...section,
    nestingLevel: currentLevel,
    subsections: section.subsections
      ? addNestingLevelToSections(section.subsections, currentLevel + 1)
      : section.subsections,
  }));
};

export const processOutlineWithNesting = (outline) => {
  if (!outline?.outlineData?.volumes) {
    return outline;
  }

  return {
    ...outline,
    outlineData: {
      ...outline.outlineData,
      volumes: outline.outlineData.volumes.map((volume) => ({
        ...volume,
        sections: addNestingLevelToSections(volume.sections, 0),
      })),
    },
  };
};

export const transformOutlineToSections = (outlineData) => {
  const sections = [];

  outlineData.volumes?.forEach((volume) => {
    sections.push({
      level: 1,
      sectionName: volume.title,
      pageCount: volume.pageLimit || "",
      notes: "",
    });

    volume.sections?.forEach((section) => {
      addSectionRecursively(sections, section, 2, 1);
    });
  });

  return sections;
};

export const updateSectionAssignees = (sections, sectionId, assignees) =>
  sections.map((section) =>
    section.id === sectionId ? { ...section, assignees } : section
  );

export const getSubsectionIds = (sections, sectionId) => {
  const sectionIndex = sections.findIndex(
    (section) => section.id === sectionId
  );

  return getChildOutlineSectionsByIndex(sections, sectionIndex).map(
    (section) => section.id
  );
};

const addSectionRecursively = (sections, section, level, nestingDepth) => {
  const indentation = "\t".repeat(nestingDepth);

  const notes = [section.complianceNotes, section.rationale]
    .filter(Boolean)
    .join("\n");

  sections.push({
    level,
    sectionName: `${indentation}${section.sectionId} - ${section.title}`,
    pageCount: "",
    notes: notes,
  });

  section.subsections?.forEach((sub) => {
    addSectionRecursively(sections, sub, level + 1, nestingDepth + 1);
  });
};
